import workflowServices from '../../../../services/work-flow'
import store from '../../../../store'
import tinymce from 'vue-tinymce-editor'
export default {
    components: {
        tinymce
    },
    data() {
        return {
            title: '',
            formType: '',
            item: [],
            communicationId: null,
            orgType: store.state.userType,
            providerCommunicationId: null,
            communicationType: '',
            tinyOptions: {
                height: 280,
                branding: false,
                statusbar: false,
                nonbreaking_force_tab: true,
                indentation: '30pt',
                content_style: 'p {font-size: 16px;color: #666666;font-family: Helvetica,Arial,sans-serif;}',
                setup: (editor) => {
                    editor.on('keydown', (evt) => {
                        if (evt.keyCode === 9) {
                            editor.execCommand('mceInsertContent', false, '&emsp;&emsp;&emsp;')
                            evt.preventDefault()
                        }
                    })
                    editor.on('Change KeyUp', () => {
                        this.email_bodyContent = editor.getContent()
                    })
                },
                init_instance_callback: (editor) => {
                    if (this.cachedBodyContent) {
                        editor.setContent(this.cachedBodyContent)
                        this.email_bodyContent = this.cachedBodyContent
                    }
                    this.tinyReady = true
                }
            },

            emailItem: {
                email_type: null,
                subject: null,
                content: null,
                parameters: null
            },
            email_bodyContent: null,
            admin: [],
            recall_items: null,
            cachedBodyContent: '',
            isEditorVisible: false,
            editorKey: 0,
            cachedSubject: '',
            DelegateListitems: [],
            tinyReady: false,
        }
    },
    methods: {
        forceRerenderView(item,communicationId,type,providerCommunicationId,communicationType,bodyContent, subject, delegateListitems) {
            this.communicationId=communicationId
            this.providerCommunicationId=providerCommunicationId
            this.item = item
            this.communicationType = communicationType
            this.title = 'Delegate Reminder'
            this.formType = type
            this.cachedBodyContent = bodyContent || ''
            this.email_bodyContent = bodyContent == null ? '' : subject
            this.cachedSubject = subject || ''
            this.DelegateListitems = delegateListitems || []
            this.$refs.modal.show()
        },
        onModalShown() {
            this.tinyReady = false
            this.$nextTick(() => {
                setTimeout(() => {
                    this.isEditorVisible = true
                    this.editorKey = Date.now()
                    this.tinyReady = true
                }, 100)
            })
        },
        onModalHidden() {
            try {
                const editor = window.tinymce?.get('d2')
                if (editor && typeof editor.destroy === 'function') {
                    editor.destroy()
                }
            } catch (err) {
                console.warn('TinyMCE cleanup error:', err)
            }
            this.tinyReady = false
            this.isEditorVisible = false
            this.editorKey = 0
            this.email_bodyContent = ''
            this.cachedBodyContent = ''
            this.$parent.ResetDelegateSelectedData()
        },
        cancel() {
            this.$refs.modal.hide()
        },
        save()
        {
            let formData = new FormData()
            formData.append('delegateEmailContent', this.email_bodyContent)
            for (let item of this.DelegateListitems) {
                formData.append('selectedDelegateId', item.delegate_id)
            }
            workflowServices.ResendDelegateMail(formData, this.communicationId, this.item !=null?this.item.delegate_id:0,(this.orgType == 'PROVIDER' ? (this.providerCommunicationId == undefined ? this.$route.params.providerCommunicationId : this.providerCommunicationId) : 0),this.communicationType).then(resp => {
                if (!resp.error) {
                    this._showToast('Email sent successfully!')
                    this.$refs.modal.hide()
                    this.$parent.FetchEmailList()
                    this.$parent.ResetDelegateSelectedData()
                    this.onModalHidden()
                }
            })
        }
    }

}